export default {"src":"/_next/static/media/logoSitterWhite.ef261cec.svg","height":69,"width":134,"blurWidth":0,"blurHeight":0};